// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/ImageCommentPin.test.tsx
import { type BaseTicketComment } from "@mg/schemas/src/christo/catalyst";
import { createContext } from "react";

/** What a closed group's pin holds, and the name a screen reader reads for it. */
export type PinCluster = {
  /** The group's letter, printed where a finding's pin prints its number. */
  mark: string;
  critical: number;
  minor: number;
  label: string;
};

/**
 * The group a pin stands for, or null for a pin that is one finding.
 *
 * Set only by the Ask v2 review while its pins are grouped: every closed group,
 * one finding or many, is drawn as one pin, a pill with its letter counting its
 * findings to fix and its minor ones.
 *
 * why a context and not a prop: the same reason `PinToneContext` gives; the
 * pins render inside the viewers nested in `AssetViewerPane`.
 */
export const PinClusterContext = createContext<
  ((comment: BaseTicketComment) => PinCluster | null) | null
>(null);
